import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'

/**
 * Displays information about the submitter of a measurement
 *
 * @todo Use correct cell component once server sends verbose data (resolved submitter)
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmSubmitter = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)

  const address = props?.submitter?.refs?.organisation?.[0]?.value?.address
    || {}
  const {
    name = null,
    firstName = null,
    lastName = null,
  } = props?.submitter?.refs?.person?.[0]?.value || {}

  const addressSummary = intl.address(address, { inline: true })
  const fullName = (firstName && lastName && `${firstName} ${lastName}`)
    || name
    || '-'

  return (
    <>
      <Text
        title={fullName}
        color={'black'}
        variant={'body2'}
        className={classes.row}
        style={{ fontWeight: props.note ? 'light' : 'bold' }}
      >
        {fullName}
      </Text>
      <Text
        variant={'14/regular'}
        title={addressSummary}
        color={'textSecondary'}
        className={classes.row}
      >
        {addressSummary}
      </Text>
    </>
  )
}

export default CellHOC(ListItemCellXEcoApmSubmitter)
